import * as React from 'react';
import * as cashTransferStyle from '../styles.scss';
import * as styles from './styles.scss';
import { AccountType, SystemType, TransferType } from 'constants/enum';
import { BrokerFunction, IBrokerPhoneCode } from 'interfaces/common';
import { Fallback, OtpModal } from 'components/common';
import {
  IDerCashTransferParams,
  IParamsDoInternalTransfer,
} from 'interfaces/api';
import { IState } from 'redux/global-reducers';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { debounce } from 'utils/delay';
import { doCashTransfer, doDerivativeInternalCashTransfer } from '../action';
import { getAuthorizedBroker, handleError } from 'utils/common';
import { queryBrokerSubAccount, querySubAccount } from './action';
import {
  queryDerivativeTransferableAmount,
  queryTransferableAmount,
} from 'redux/global-actions';
import { withErrorBoundary } from 'react-error-boundary';
import Benificiary, { IDropdownData } from '../Common/Beneficiary';
import CashTransferNote from '../Common/CashTransferNote';
import SendingAccount from '../Common/SendingAccount';

export interface ICashTransferInternalSubProps
  extends React.ClassAttributes<CashTransferInternalSubComponent>,
    WithNamespaces {
  readonly selectedAccount: IState['selectedAccount'];
  readonly equityTransferableAmount: IState['equityTransferableAmount'];
  readonly equitySubAccount: IState['equitySubAccount'];
  readonly equityBrokerSubAccount: IState['equityBrokerSubAccount'];
  readonly derivativeTransferableAmount: IState['derivativeTransferableAmount'];
  readonly equityCashTransferResult: IState['equityCashTransferResult'];
  readonly derivativeInternalCashTransferResult: IState['derivativeInternalCashTransferResult'];
  readonly accountList: IState['accountList'];
  readonly brokerVerifyPin: IState['brokerVerifyPin'];

  readonly queryTransferableAmount: typeof queryTransferableAmount;
  readonly queryDerivativeTransferableAmount: typeof queryDerivativeTransferableAmount;
  readonly querySubAccount: typeof querySubAccount;
  readonly queryBrokerSubAccount: typeof queryBrokerSubAccount;
  readonly doCashTransfer: typeof doCashTransfer;
  readonly doDerivativeInternalCashTransfer: typeof doDerivativeInternalCashTransfer;
  readonly onSelectVSD: (bank: boolean, VSD: boolean) => void;
}

export interface ICashTransferInternalSubState {
  readonly transferAmount: number;
  readonly beneficiaryAccountNo: string;
  readonly content: string;
  readonly phoneCode: string;
  readonly phoneCodeError: boolean;
  readonly openPopup: boolean;
}
class CashTransferInternalSubComponent extends React.Component<
  ICashTransferInternalSubProps,
  ICashTransferInternalSubState
> {
  private localAccountData: IDropdownData[] | [] = [];
  private localIsDerivatives: boolean;

  private localBrokerVerifyPin: IBrokerPhoneCode | null = getAuthorizedBroker(
    this.props.brokerVerifyPin,
    this.props.selectedAccount,
    BrokerFunction.CASH_TRANSFER_INTERNAL
  );

  constructor(props: ICashTransferInternalSubProps) {
    super(props);

    this.state = {
      transferAmount: 0,
      beneficiaryAccountNo: '',
      content: '',
      phoneCode: '',
      phoneCodeError: false,
      openPopup: false,
    };
  }

  componentDidMount() {
    this.props.onSelectVSD(false, false);
    this.localIsDerivatives =
      this.props.selectedAccount?.type === SystemType.DERIVATIVES;

    if (!this.props.selectedAccount?.isBrokerCall) {
      this.queryTransferableAmount(this.props.selectedAccount?.account);

      this.props.querySubAccount({
        clientID: this.props.selectedAccount?.username,
      });
    }
    if (
      this.props.selectedAccount?.isBrokerCall &&
      this.localBrokerVerifyPin?.isAuthorized
    ) {
      this.queryTransferableAmount(this.props.selectedAccount?.account);
      this.props.queryBrokerSubAccount({
        clientID: this.props.selectedAccount?.clientID,
      });
    }
  }

  shouldComponentUpdate(nextProps: ICashTransferInternalSubProps) {
    if (
      this.props.brokerVerifyPin !== nextProps.brokerVerifyPin ||
      (this.props.selectedAccount !== nextProps.selectedAccount &&
        nextProps.selectedAccount?.isBrokerCall)
    ) {
      this.localIsDerivatives =
        nextProps.selectedAccount?.type === SystemType.DERIVATIVES;

      if (nextProps.selectedAccount != null) {
        this.localBrokerVerifyPin = getAuthorizedBroker(
          nextProps.brokerVerifyPin,
          nextProps.selectedAccount,
          BrokerFunction.CASH_TRANSFER_INTERNAL
        );
        if (
          this.localBrokerVerifyPin != null &&
          this.localBrokerVerifyPin.isAuthorized
        ) {
          this.queryTransferableAmount(
            nextProps.selectedAccount?.account,
            this.localBrokerVerifyPin.clientID
          );
          this.props.queryBrokerSubAccount({
            clientID: nextProps.selectedAccount?.clientID,
          });
        }
      }
    }

    if (
      nextProps.equitySubAccount.data &&
      nextProps.equitySubAccount.data !== this.props.equitySubAccount.data
    ) {
      this.localIsDerivatives =
        nextProps.selectedAccount?.type === SystemType.DERIVATIVES;
      const defaultSubAccount = nextProps.equitySubAccount.data.find(
        (subAccount) => subAccount.defaultSubAccount
      );

      const derivativeAccount = nextProps.accountList.find(
        (account) => account.accountType === AccountType.DERIVATIVES
      );

      this.localAccountData = nextProps.equitySubAccount.data
        .filter((account) => {
          if (this.localIsDerivatives) {
            return account.defaultSubAccount;
          }

          return defaultSubAccount?.subAccountID ===
            nextProps.selectedAccount?.account
            ? account.subAccountID !== nextProps.selectedAccount?.account
            : account.subAccountID !== nextProps.selectedAccount?.account &&
                account.subAccountID !== derivativeAccount?.account;
        })
        .map((account) => {
          return { title: account.subAccountID, value: account.subAccountID };
        });
    }

    if (
      nextProps.equityBrokerSubAccount.data &&
      nextProps.equityBrokerSubAccount.data !==
        this.props.equityBrokerSubAccount.data
    ) {
      this.localIsDerivatives =
        nextProps.selectedAccount?.type === SystemType.DERIVATIVES;

      const defaultSubAccount = nextProps.equityBrokerSubAccount.data.find(
        (subAccount) => subAccount.defaultSubAccount
      );

      const derivativeAccount = nextProps.accountList.find(
        (account) =>
          account.type === SystemType.DERIVATIVES &&
          account.clientID === nextProps.selectedAccount?.clientID
      );

      this.localAccountData = nextProps.equityBrokerSubAccount.data
        .filter((account) => {
          if (this.localIsDerivatives) {
            return account.defaultSubAccount;
          }
          return defaultSubAccount?.subAccountID ===
            nextProps.selectedAccount?.account
            ? account.subAccountID !== nextProps.selectedAccount?.account
            : account.subAccountID !== nextProps.selectedAccount?.account &&
                account.subAccountID !== derivativeAccount?.account;
        })
        .map((account) => {
          return { title: account.subAccountID, value: account.subAccountID };
        });

      if (
        defaultSubAccount?.subAccountID ===
          nextProps.selectedAccount?.account &&
        derivativeAccount
      ) {
        this.localAccountData.push({
          title: derivativeAccount.account,
          value: derivativeAccount.account,
        });
      }
    }

    if (this.props.selectedAccount !== nextProps.selectedAccount) {
      if (!nextProps.selectedAccount?.isBrokerCall) {
        this.localIsDerivatives =
          nextProps.selectedAccount?.type === SystemType.DERIVATIVES;

        if (nextProps.selectedAccount?.isBrokerCall) {
          this.props.queryBrokerSubAccount({
            clientID: nextProps.selectedAccount?.clientID,
          });
        } else {
          this.queryTransferableAmount(nextProps.selectedAccount?.account);
          this.props.querySubAccount({
            clientID: nextProps.selectedAccount?.username,
          });
        }
      }
    }

    if (
      (this.props.derivativeInternalCashTransferResult !==
        nextProps.derivativeInternalCashTransferResult &&
        nextProps.derivativeInternalCashTransferResult.status.isSucceeded) ||
      (this.props.equityCashTransferResult !==
        nextProps.equityCashTransferResult &&
        nextProps.equityCashTransferResult.status.isSucceeded)
    ) {
      this.queryTransferableAmount(nextProps.selectedAccount?.account);
    }
    return true;
  }

  render() {
    const { selectedAccount } = this.props;
    const isShowPhoneCode =
      this.localBrokerVerifyPin &&
      this.localBrokerVerifyPin.clientID === selectedAccount?.clientID &&
      this.localBrokerVerifyPin.isAuthorized;

    return (
      <div className={cashTransferStyle.CashTransferContent}>
        <div>
          <SendingAccount
            transferAmount={
              this.localIsDerivatives
                ? this.props.derivativeTransferableAmount.data
                    ?.transferableAmountToInternalSubsOrToBank
                : this.props.equityTransferableAmount.data?.transferableAmount
            }
            isShowPhoneCode={
              isShowPhoneCode === null ? undefined : isShowPhoneCode
            }
            brokerFunction={BrokerFunction.CASH_TRANSFER_INTERNAL}
          />
          <CashTransferNote />
        </div>
        <div>
          <Benificiary
            transferableAmount={
              this.localIsDerivatives
                ? this.props.derivativeTransferableAmount.data
                    ?.transferableAmountToInternalSubsOrToBank
                : this.props.equityTransferableAmount.data?.transferableAmount
            }
            modalTitle={'Transfer cash to internal sub account'}
            accountData={this.localAccountData}
            onChangeTransferAmount={this.onChangeTransferAmount}
            transferAmount={this.state.transferAmount}
            onConfirm={this.onConfirmTransfer}
            onChangeContent={this.onChangeContent}
            onChangeBeneficiaryAccount={this.onChangeBeneficiaryAccount}
            onReset={this.onReset}
            content={this.state.content}
          />
        </div>
        <OtpModal
          show={this.state.openPopup}
          onHide={this.onHideModal}
          onSubmit={this.doCallCashTransfer}
        >
          <div className={styles.ConfirmCashTransfer}>
            {this.props.equityTransferableAmount.data?.withdrawWRNMsg}
          </div>
        </OtpModal>
      </div>
    );
  }

  private onHideModal = () => {
    this.setState({ openPopup: false });
  };

  private onChangeBeneficiaryAccount = (value: string) => {
    this.setState({ beneficiaryAccountNo: value });
  };

  private onChangeContent = (value: string) => {
    this.setState({ content: value });
  };

  private onChangeTransferAmount = (value: number) => {
    this.setState({ transferAmount: value });
    debounce(this.queryTransferableAmountAndWaitingCash, 1000)(value);
  };

  private queryTransferableAmountAndWaitingCash = (value: number) => {
    if (this.localIsDerivatives) {
      this.props.queryDerivativeTransferableAmount({
        accountNo: this.props.selectedAccount?.account,
        withdrawAmt: `${value}`,
      });
    } else {
      this.props.queryTransferableAmount({
        accountNo: this.props.selectedAccount?.account,
        withdrawAmt: `${value}`,
      });
    }
  };

  private onReset = () => {
    this.setState({ transferAmount: 0, beneficiaryAccountNo: '', content: '' });
  };

  private queryTransferableAmount = (accountNo?: string, clientID?: string) => {
    if (this.props.selectedAccount?.isBrokerCall) {
      if (this.localIsDerivatives) {
        this.props.queryDerivativeTransferableAmount({
          accountNo,
          clientID: clientID ?? this.props.selectedAccount?.clientID,
        });
      } else {
        this.props.queryTransferableAmount({
          accountNo,
          clientID: clientID ?? this.props.selectedAccount?.clientID,
        });
      }
    } else {
      if (this.localIsDerivatives) {
        this.props.queryDerivativeTransferableAmount({ accountNo });
      } else {
        this.props.queryTransferableAmount({ accountNo });
      }
    }
  };

  private onConfirmTransfer = () => {
    if (this.props.equityTransferableAmount.data?.withdrawWRNMsg) {
      this.setState({ openPopup: true });
    } else {
      this.doCallCashTransfer();
    }
  };

  private doCallCashTransfer = () => {
    const beneficiaryAccount = this.props.accountList?.find(
      (account) => account.account === this.state.beneficiaryAccountNo
    );
    const isTransferToDer = beneficiaryAccount?.type === SystemType.DERIVATIVES;
    if (this.localIsDerivatives || isTransferToDer) {
      const param: IDerCashTransferParams = {
        accountNumber: isTransferToDer
          ? this.state.beneficiaryAccountNo
          : this.props.selectedAccount?.account,
        transferType: isTransferToDer
          ? TransferType.EQT_TO_DR
          : TransferType.DR_TO_EQT,
        transferAmount: this.state.transferAmount,
        transferableAmount: isTransferToDer
          ? this.props.equityTransferableAmount.data?.transferableAmount
          : this.props.derivativeTransferableAmount.data
              ?.transferableAmountToInternalSubsOrToBank,
        content: this.state.content,
      };
      if (this.props.selectedAccount?.isBrokerCall) {
        this.props.doDerivativeInternalCashTransfer({
          ...param,
          clientID: this.props.selectedAccount?.clientID,
          pin: this.localBrokerVerifyPin?.pin,
        });
      } else {
        this.props.doDerivativeInternalCashTransfer(param);
      }
    } else {
      const param: IParamsDoInternalTransfer = {
        transferType: TransferType.TO_SUB,
        senderAccountNo: this.props.selectedAccount?.account,
        senderFullName: this.props.selectedAccount?.accountName,
        transferableAmount: this.props.equityTransferableAmount.data
          ?.transferableAmount,
        beneficiaryAccountNo: this.state.beneficiaryAccountNo,
        beneficiaryFullName: this.props.selectedAccount?.accountName,
        transferAmount: this.state.transferAmount,
        content: this.state.content,
        transferFee: 0,
      };
      if (this.props.selectedAccount?.isBrokerCall) {
        this.props.doCashTransfer({
          ...param,
          clientID: this.props.selectedAccount?.clientID,
          pin: this.localBrokerVerifyPin?.pin,
        });
      } else {
        this.props.doCashTransfer(param);
      }
    }
    this.onHideModal();
  };
}

const mapStateToProps = (state: IState) => ({
  selectedAccount: state.selectedAccount,
  equityTransferableAmount: state.equityTransferableAmount,
  equitySubAccount: state.equitySubAccount,
  equityBrokerSubAccount: state.equityBrokerSubAccount,
  accountList: state.accountList,
  derivativeTransferableAmount: state.derivativeTransferableAmount,
  equityCashTransferResult: state.equityCashTransferResult,
  derivativeInternalCashTransferResult:
    state.derivativeInternalCashTransferResult,
  brokerVerifyPin: state.brokerVerifyPin,
});

const mapDispatchToProps = {
  queryTransferableAmount,
  queryDerivativeTransferableAmount,
  querySubAccount,
  queryBrokerSubAccount,
  doCashTransfer,
  doDerivativeInternalCashTransfer,
};

const CashTransferInternalSub = withErrorBoundary(
  withNamespaces('common')(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(CashTransferInternalSubComponent)
  ),
  Fallback,
  handleError
);

export default CashTransferInternalSub;



// WEBPACK FOOTER //
// ./src/components/areas/Account/CashTransfer/CashTransferInternalSub/index.tsx